globalThis.Pen = class Pen {
  constructor() {
    this.mouse0down = false;
    this.mouse2down = false;
    this.clientX = 0;
    this.clientY = 0;
    this.cursorX = 0;
    this.cursorY = 0;
    this.cursor = document.createElement("div");
    this.cursor.id = "cursor";
    globalThis.WORLD.div.append(this.cursor);
    this.abort = new AbortController();
    globalThis.WORLD.div.addEventListener(
      "mousedown",
      this.onMousedown.bind(this),
      this.abort,
    );
    addEventListener("mouseup", this.onMouseup.bind(this), this.abort);
    addEventListener("mousemove", this.onMousemove.bind(this), this.abort);
    addEventListener("addcontrol", this.onControl.bind(this), this.abort);
    addEventListener("removecontrol", this.onControl.bind(this), this.abort);
    this.selector = new BlockSelector();
    this.selector.hide();
  }

  remove() {
    this.abort.abort();
    this.selector.remove();
  }

  onControl(event) {
    if (event.detail !== "pen") return;
    if (this.isActive()) this.selector.show();
    else this.selector.hide();
  }

  isActive() {
    return globalThis.TOPBAR.hasControl("pen");
  }

  onMousedown(event) {
    if (!this.isActive()) return;
    if (event.button === 0) {
      this.mouse0down = true;
      this.placeBlockAtCursor();
    } else if (event.button === 2) {
      this.mouse2down = true;
      this.removeBlockAtCursor();
    }
  }

  onMouseup(event) {
    if (!this.isActive()) return;
    if (event.button === 0) this.mouse0down = false;
    else if (event.button === 2) this.mouse2down = false;
  }

  onMousemove(event) {
    if (!this.isActive()) return;
    this.clientX = event.clientX;
    this.clientY = event.clientY;
    const { x, y } = this.getWorldPosition();
    this.cursorX = x;
    this.cursorY = y;
    this.setCursorPosition(x, y);
    if (this.mouse0down) this.placeBlockAtCursor();
    else if (this.mouse2down) this.removeBlockAtCursor();
  }

  getWorldPosition() {
    const rect = globalThis.WORLD.div.getBoundingClientRect();
    const x = this.clientX - rect.left;
    const y = this.clientY - rect.top;
    const result = new Vector2(x, y)
      .div(globalThis.UNIT)
      .div(globalThis.WORLD.scale)
      .sub(new Vector2(1, 1))
      .floor();
    result.x = Math.max(-1, Math.min(result.x, globalThis.WORLD.size.x));
    result.y = Math.max(-1, Math.min(result.y, globalThis.WORLD.size.y));
    return result;
  }

  setCursorPosition(x, y) {
    this.cursor.style.setProperty("--x", x);
    this.cursor.style.setProperty("--y", y);
  }

  placeBlockAtCursor() {
    globalThis.CLIENT.addBlock(this.cursorX, this.cursorY, this.selector.index);
  }

  removeBlockAtCursor() {
    globalThis.CLIENT.removeBlockAt(this.cursorX, this.cursorY);
  }
};
